import { createFileRoute, redirect } from "@tanstack/react-router";
import { requireModule } from "@/lib/module-access";

/** Legacy deep link retained after Campaign AI configuration moved into its Paper dialog. */
export const Route = createFileRoute("/_authed/campaigns/$id/ai-setup")({
  beforeLoad: ({ params }) => {
    requireModule("campaigns");
    throw redirect({ to: "/campaigns/$id", params: { id: params.id } });
  },
});
